import { useReports } from '@sail/observability';
import { once } from '@sail/utils';
import { createContext, useContext } from 'react';
import { defaultNavigationConfig } from '../../internal/config/defaultConfig';
class NavigationConfigError extends Error {
    constructor(message){
        super(`[@sail/navigation] ${message}`);
    }
}
export const uninitializedNavigationConfigError = ()=>new NavigationConfigError('Make sure to provide the required config for navigation to NavigationProvider upon initialization.');
const reportUninitializedErrorOnce = once((reportError)=>{
    reportError(uninitializedNavigationConfigError(), {
        tags: {
            namespace: 'navigation'
        }
    });
});
export const NavigationConfigContext = /*#__PURE__*/ createContext(defaultNavigationConfig);
export function useNavigationConfig() {
    const config = useContext(NavigationConfigContext);
    const { error } = useReports();
    if (!config) {
        reportUninitializedErrorOnce(error);
        throw uninitializedNavigationConfigError();
    }
    return config;
}

//# sourceMappingURL=NavigationConfigContext.js.map